import { render, staticRenderFns } from "./serviceCountrywise.vue?vue&type=template&id=3e81ee4f&scoped=true"
import script from "./serviceCountrywise.vue?vue&type=script&lang=js"
export * from "./serviceCountrywise.vue?vue&type=script&lang=js"
import style0 from "./serviceCountrywise.vue?vue&type=style&index=0&id=3e81ee4f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e81ee4f",
  null
  
)

export default component.exports